/* EhubAmerica PDP v3. Vanilla, deferred, scoped to [data-pdp3] roots.
   Add to cart itself is handled by the site-wide cart drawer ([data-ehub-add-to-cart]). */
(function () {
  'use strict';

  function initMain(root) {
    // Gallery: thumbnail -> main image
    var stage = root.querySelector('[data-pdp3-stage]');
    var thumbs = root.querySelectorAll('[data-pdp3-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!stage) return;
        stage.src = t.getAttribute('data-src');
        stage.srcset = t.getAttribute('data-srcset') || '';
        stage.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (o) { if (o === t) { o.setAttribute('aria-current', 'true'); } else { o.removeAttribute('aria-current'); } });
      });
    });

    // Quantity stepper keeps every add-to-cart button in this root in sync
    var input = root.querySelector('[data-pdp3-qty-input]');
    var atcs = root.querySelectorAll('[data-ehub-add-to-cart]');
    function clamp() {
      var v = parseInt(input.value, 10);
      if (!isFinite(v) || v < 1) v = 1;
      if (v > 999) v = 999;
      input.value = v;
      atcs.forEach(function (b) { b.setAttribute('data-quantity', String(v)); });
    }
    if (input) {
      input.addEventListener('change', clamp);
      input.addEventListener('blur', clamp);
      root.querySelectorAll('[data-pdp3-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-pdp3-qty'), 10);
          clamp();
        });
      });
    }

    // Announce add-to-cart for assistive tech (drawer handles the request)
    var live = root.querySelector('[data-pdp3-live]');
    atcs.forEach(function (b) {
      b.addEventListener('click', function () {
        if (live) live.textContent = 'Adding to cart';
      });
    });
    window.addEventListener('ehub:cart-updated', function () {
      if (live) live.textContent = 'Added to cart';
    });

    // Copy part number / SKU
    root.querySelectorAll('[data-pdp3-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var val = b.getAttribute('data-pdp3-copy') || '';
        var done = function () {
          var old = b.textContent; b.textContent = 'Copied';
          if (live) live.textContent = 'Copied ' + val;
          setTimeout(function () { b.textContent = old; }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(val).then(done, function () {});
      });
    });

    // Professional programming: when checked, add radio + service together (same quantity),
    // with the radio SKU / part number recorded on the service line.
    var prog = root.querySelector('[data-pdp3-prog]');
    var progFields = root.querySelectorAll('[data-pdp3-prog-qty], [data-pdp3-prog-prop]');
    function syncProg() {
      if (!prog) return;
      progFields.forEach(function (el) { el.disabled = !prog.checked; });
      var q = root.querySelector('[data-pdp3-prog-qty]');
      if (q && input) q.value = input.value;
    }
    if (prog) {
      // Server markup ships the option hidden and disabled; enable it only when this script runs.
      var progWrap = root.querySelector('[data-pdp3-prog-wrap]');
      if (progWrap) progWrap.hidden = false;
      prog.disabled = false;
      prog.addEventListener('change', syncProg);
      if (input) input.addEventListener('change', syncProg);
      atcs.forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (!prog.checked) return; // default path: site cart drawer
          e.preventDefault();
          e.stopPropagation();
          var qty = parseInt(b.getAttribute('data-quantity') || '1', 10) || 1;
          var props = { 'For SKU': b.getAttribute('data-sku') || '' };
          if (b.getAttribute('data-mpn')) props['For part number'] = b.getAttribute('data-mpn');
          b.disabled = true;
          if (live) live.textContent = 'Adding radio and programming to cart';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [
              { id: Number(b.getAttribute('data-variant-id')), quantity: qty },
              { id: Number(prog.getAttribute('data-variant-id')), quantity: qty, properties: props }
            ] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return window.ehubCart && window.ehubCart.refresh ? window.ehubCart.refresh() : null;
          }).then(function () {
            window.dispatchEvent(new CustomEvent('ehub:cart-updated'));
            if (window.ehubCart && window.ehubCart.open) window.ehubCart.open();
          }).catch(function () {
            if (live) live.textContent = 'Could not add to cart. Please try again.';
          }).then(function () { b.disabled = false; });
        });
      });
      syncProg();
    }

    // Variant select: reload with ?variant= so everything renders server-side
    var form = root.querySelector('[data-pdp3-variant-form]');
    var sel = root.querySelector('[data-pdp3-variant]');
    if (form && sel) {
      sel.addEventListener('change', function () { form.submit(); });
    }
  }

  function initSpecs(wrap) {
    var btn = wrap.querySelector('[data-pdp3-specs-toggle]');
    if (!btn) return;
    wrap.classList.add('is-collapsed');
    btn.hidden = false;
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = btn.getAttribute('data-label-more');
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = btn.getAttribute(open ? 'data-label-less' : 'data-label-more');
    });
  }

  function init() {
    document.querySelectorAll('[data-pdp3]').forEach(initMain);
    document.querySelectorAll('[data-pdp3-specs]').forEach(initSpecs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();